"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUuidToRandomNumberInRange = convertUuidToRandomNumberInRange;
function convertUuidToRandomNumberInRange(uuid, rangeTo) {
    const uuidConstantRandom = parseInt(uuid.slice(-4), 16) % rangeTo;
    return uuidConstantRandom;
}
//# sourceMappingURL=convertUuidToRandomNumberInRange.js.map